export enum NotificationTabsEnums {
  users = 'users',
  payment = 'payment',
  support = 'support',
  custom = 'custom',
}

export enum NotificationsModelTypeAdmin {
  reservationCreatedAdmin = 'App\\Notifications\\Reservation\\ReservationCreatedAdmin',
  reservationCreatedAdminGifts = 'App\\Notifications\\Reservation\\ReservationCreatedAdminGifts',
  userCreated = 'App\\Notifications\\User\\UserCreated',
  cancelledByBusiness = 'App\\Notifications\\Reservation\\ReservationCanceledByBusinessForAdmin',
  cancelledByUser = 'App\\Notifications\\Reservation\\ReservationCanceledByUserForAdmin',
  supportNotification = 'ChangeRequestCreated',
}
